import React from "react";

export function ZapierIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      enable-background="new 0 0 24 24"
      viewBox="0 0 24 24"
      width="24"
      height="24"
    >
      <path d="M23.835,10H16.83l4.948-4.952c-0.39-0.548-0.82-1.06-1.295-1.533c-0.473-0.474-0.985-0.907-1.53-1.296l-4.954,4.949V0.165C13.35,0.061,12.686,0,12.004,0h-0.01c-0.68,0-1.346,0.061-1.995,0.165V7.17l-4.95-4.949C4.5,2.607,3.989,3.042,3.515,3.515C3.041,3.988,2.607,4.502,2.219,5.048L7.168,10H0.165C0.165,10,0,11.316,0,11.995v0.009c0,0.68,0.061,1.348,0.165,1.995H7.17l-4.949,4.952c0.777,1.096,1.733,2.051,2.827,2.83L10,16.831v7.004C10.648,23.94,11.313,24,11.991,24h0.017c0.679,0,1.344-0.06,1.991-0.165v-7.004l4.952,4.95c0.548-0.375,1.06-0.812,1.529-1.29h0.005c0.473-0.465,0.906-0.976,1.296-1.531l-4.95-4.949h7.004C23.94,13.366,24,12.707,24,12.031V12c0-0.678-0.06-1.343-0.165-1.99V10z M15,12.004c0,0.893-0.165,1.746-0.461,2.535C13.752,14.836,12.896,15,12.004,15h-0.009c-0.893,0-1.745-0.165-2.534-0.461C9.164,13.75,9,12.896,9,12.004v-0.009c0-0.893,0.164-1.745,0.461-2.534C10.25,9.164,11.103,9,11.995,9h0.009c0.893,0,1.748,0.164,2.535,0.462C14.836,10.25,15,11.103,15,11.997V12.004z" />
    </svg>
  );
}
